module.exports = __webpack_public_path__ + "a30401d8c81eac7c3fc43d871cde07b9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-police.png
// module id = 1350
// module chunks = 0